var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenarioTopRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 375,
    viewBox: "0 0 231 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 0.845703C221.5 0.845703 -28.63 106.136 3.38996 211.656C16.6338 255.242 45.2586 292.534 83.9399 316.596C116.94 337.116 174.68 368.166 231 374.896V0.845703H221.5Z",
    fill: "#7AB7DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.001 -0.154297C231.001 -0.154297 -20.0894 98.1557 10.8806 196.666C23.8006 237.786 51.8206 272.476 88.7806 294.666C120.691 313.846 176.531 342.846 231.001 349.086L231.001 -0.154297Z",
    fill: "url(#paint0_linear_1142_152)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133 208.846C146.255 208.846 157 198.101 157 184.846C157 171.591 146.255 160.846 133 160.846C119.745 160.846 109 171.591 109 184.846C109 198.101 119.745 208.846 133 208.846Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173 158.846C179.627 158.846 185 153.473 185 146.846C185 140.218 179.627 134.846 173 134.846C166.373 134.846 161 140.218 161 146.846C161 153.473 166.373 158.846 173 158.846Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123 145.846C132.389 145.846 140 138.235 140 128.846C140 119.457 132.389 111.846 123 111.846C113.611 111.846 106 119.457 106 128.846C106 138.235 113.611 145.846 123 145.846Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170 119.846C174.971 119.846 179 115.816 179 110.846C179 105.875 174.971 101.846 170 101.846C165.029 101.846 161 105.875 161 110.846C161 115.816 165.029 119.846 170 119.846Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1142_152",
    x1: 119.618,
    y1: -0.154297,
    x2: 119.618,
    y2: 349.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2980B9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2980B9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenarioTopRight);
export default __webpack_public_path__ + "static/media/Cenario_top_right.94b0768048bb1299dfd3a26479bcabfb.svg";
export { ForwardRef as ReactComponent };